function ConfirmationModal() {

}

/** 
 * @param data object (header, message)
 * 
 * */ 

ConfirmationModal.init = function(data, confirmCallback, rejectCallback) {
    var template = _.template($("#confirmation-message-tmpl").html());
    var container = $("#confirmation-modal .confirmation-content");

    $(container).html("");
    $(container).html(template({
        data: data
    }));

    $("#confirmation-modal .confirmed").click(function() {
        console.log("Confirm")
        if (_.isFunction(confirmCallback)) {
            confirmCallback();
        }

        UIkit.modal("#confirmation-modal").hide();
    });

    $("#confirmation-modal .cancel").click(function() {
        console.log("Reject")
        if (_.isFunction(rejectCallback)) {
            rejectCallback();
        }

        UIkit.modal("#confirmation-modal").hide();
    });

    UIkit.modal("#confirmation-modal").show();
}

ConfirmationModal.hide = function() {
    UIkit.modal("#confirmation-modal").hide();
}